module.exports = __webpack_public_path__ + "static/city_icon_182-5e55244c20d3723e09b99eb975943601.png";